'use strict';

module.exports = {
    /**
     * 调用 scheme 获取回执<br />
     * 对应native接口：schemeForResult
     * @method hysdk.schemeForResult
     * @category Schema
     * @example ./schemeForResult.js[1-18]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | scheme | String | scheme 地址 | √ | 常用参数 |
     * | success | Function | success 回调 | X | 常用参数 |
     * | fail | Function | fail 回调 | X | 常用参数 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    schemeForResult: {
        hy: {
            key: 'schemeForResult'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/scheme.js
// module id = 21
// module chunks = 0 2 4